import api from './api';

const list = async (params = {}) => {
  const { data } = await api.get('/messages/conversations', { params });
  return data;
};

const get = async (id) => {
  const { data } = await api.get(`/messages/conversations/${id}`);
  return data;
};

// create payloads:
// - ADMIN (WHS↔RTL): { subject, wholesalerId|wholesalerEmail, customerId|customerEmail, inbox?, tags?, links? }
// - ADMIN (Admin↔Admin): { subject, inbox:'admin', adminPeerId|adminPeerEmail, tags?, links? }
// - WHS:   { subject, customerId, inbox?, tags?, links? }
// - RTL:   { subject, wholesalerId, inbox?, tags?, links? }
const create = async (payload) => {
  const { data } = await api.post('/messages/conversations', payload);
  return data;
};

export async function deleteConversation(id, opts = {}) {
  const params = {};
  if (opts.hard) params.hard = true;
  const res = await api.delete(`/messages/conversations/${id}`, { params });
  return res.data;
}

const update = async (id, payload) => {
  const { data } = await api.patch(`/messages/conversations/${id}`, payload);
  return data;
};

const typing = async (id, isTyping) => {
  const { data } = await api.post(`/messages/conversations/${id}/typing`, { isTyping });
  return data;
};

const conversationService = { list, get, create, update, typing, deleteConversation };
export default conversationService;
